import axios from 'axios'

const getApiClient = (store = null) => {
    const api = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: true,
    })

    api.interceptors.request.use(function (config) {
        store.commit('app/startLoading')
        if (config.url === 'auth/refresh') {
          return config
        }
        const token = store.state.app.session.token
        if (token !== null) {
            config.headers.Authorization = `Bearer ${token}`
        }

        return config
    })

    api.interceptors.response.use((response) => {
        store.commit('app/stopLoading')
        return response
    }, (error) => {
        store.commit('app/stopLoading')
        if (error?.response?.status !== 401) {
            return new Promise((resolve, reject) => {
                reject(error)
            })
        }

        if (error?.config?.url === '/auth') {
            return new Promise((resolve, reject) => {
                reject(error)
            })
        }

        // Try request again with new token
        return store.dispatch('app/refreshToken')
            .then((response) => {
                const config = error.config
                const token = store.state.app.session.token

                config.headers.Authorization = `Bearer ${token}`

                return new Promise((resolve, reject) => {
                    axios.request(config).then(response => {
                        resolve(response)
                    }).catch((error) => {
                        reject(error)
                    })
                })
            })
            .catch((error) => {
                Promise.reject(error)
            })
    })

    return api
}

export default getApiClient
